import { Locale, type LocalizedString } from "../Locale.js";

export const confirmForgotPasswordPathMap = {
	[Locale.cs]: "obnova-hesla" as const,
} satisfies LocalizedString;
